import { UUID } from '@builddocs/data-management'
import { useMutation } from 'react-query'

import { updateSecondaryActNumber } from './secondary-act.service'

export const useEditSecondaryActNumber = (actId: UUID) => {
  return useMutation({
    mutationFn: ({ closingNumber }: { closingNumber: string }) =>
      updateSecondaryActNumber({ actId, closingNumber }),
  })
}
